(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
    function linkSlideImage(container) {
      if (!container || container.tagName === 'A') return;
      var slide = container.closest('slideshow-slide');
      if (!slide) return;
      var cta = slide.querySelector('.slide__content a[href]');
      if (!cta) return;
      var href = cta.getAttribute('href');
      if (!href) return;

      var anchor = document.createElement('a');
      anchor.href = href;
      if (cta.target) anchor.target = cta.target;
      anchor.setAttribute('aria-hidden', 'true');
      anchor.setAttribute('tabindex', '-1');
      for (var i = 0; i < container.attributes.length; i++) {
        var attr = container.attributes[i];
        if (attr.name === 'href') continue;
        anchor.setAttribute(attr.name, attr.value);
      }
      while (container.firstChild) anchor.appendChild(container.firstChild);
      container.replaceWith(anchor);
    }

    function init(root) {
      (root || document).querySelectorAll('[data-slide-image]').forEach(linkSlideImage);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
